import { ArrowLeft, Maximize2, Minimize2, X } from "@/components/icons"
import { Button } from "@/components/ui/button"
import i18n from "@/languageConfig"

type LocalFilePreviewSidebarHeaderProps = {
  title: string
  backLabel: string
  isFocused: boolean
  isFocusable: boolean
  closeable: boolean
  onBack?: () => void
  onToggleFocus: () => void
  onClose: () => void
}

export function LocalFilePreviewSidebarHeader({
  title,
  backLabel,
  isFocused,
  isFocusable,
  closeable,
  onBack,
  onToggleFocus,
  onClose,
}: LocalFilePreviewSidebarHeaderProps) {
  const focusLabel = isFocused
    ? i18n.t("analysispanel.exit_focus", { defaultValue: "Exit focus mode" })
    : i18n.t("analysispanel.focus", { defaultValue: "Focus mode" })
  const closeLabel = i18n.t("analysispanel.close", { defaultValue: "Close" })

  return (
    <div className="flex shrink-0 flex-col border-b">
      {onBack && (
        <div className="border-b px-1 py-1">
          <Button
            aria-label={backLabel}
            className="h-8 gap-1.5 px-2"
            size="sm"
            variant="ghost"
            onClick={onBack}
          >
            <ArrowLeft className="size-4" />
            <span className="text-sm">{backLabel}</span>
          </Button>
        </div>
      )}
      <div className="flex items-center justify-between p-2">
        <h3 className="mr-2 flex-1 truncate text-sm font-semibold">{title}</h3>
        <div className="flex items-center gap-1">
          {isFocusable && (
            <Button
              aria-label={focusLabel}
              className="h-8 w-8 shrink-0 p-0"
              size="icon"
              variant="ghost"
              onClick={onToggleFocus}
            >
              {isFocused ? <Minimize2 className="size-4" /> : <Maximize2 className="size-4" />}
            </Button>
          )}
          {closeable && (
            <Button
              aria-label={closeLabel}
              className="h-8 w-8 shrink-0 p-0"
              size="icon"
              variant="ghost"
              onClick={onClose}
            >
              <X className="size-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
